<template>
    <validation-observer ref="longtextForm">
        <div>
            <div class="form-group p-0-14">
                <validation-provider v-slot="{errors}" :rules="attribute.mandatory ? 'required' : ''">
                    <div v-if="attribute.attribute_name == 'Service Manual' || attribute.attribute_name=='Description'"
                         class="long-text-attribute ibox rotate-div">
                        <div :data-target="'#demo'+ id"
                             class="ibox-title"
                             data-toggle="collapse"
                             style="border-top: 0px;padding: 14px 15px 15px;border-radius: 12px !important;cursor: pointer;">
                            <label v-if="attribute.attribute_name == 'Service Manual'" :for="id" class="attribute-label"
                                   role="button">{{
                                    attribute.attribute_name
                                }}</label>
                            <label v-else-if="attribute.attribute_name=='Description'" :for="id" class="attribute-label"
                                   role="button">Service Details</label>
                            <div class="inline float-right">
                                <div class="inline arrow-container">
                                    <a class="" role="button">
                                        <i class="fa fa-chevron-down" style="color: #2E4051"></i>
                                    </a>
                                </div>
                            </div>

                            <div class="clearfix"></div>


                            <div :id="'demo'+ id" class="collapse">
                                <hr/>
                                <tinymce :id="id" v-model="attribute.value" :is-service-description="true" :name="name">
                                    {{
                                        attribute.value
                                    }}
                                </tinymce>
                            </div>
                        </div>
                    </div>

                    <div v-else class="text-attribute">
                        <label :for="id" class="attribute-label">
                            {{ attribute.attribute_name }}
                            <a v-if="removeTags(attribute.extra_info) !== ''"
                               :data-content="popover_custom_data(attribute.extra_info)" data-html="true" data-placement="bottom"
                               data-toggle="popover"
                               href="javascript:;"> <i class="fa fa-info-circle"></i></a>
                            <span v-if="attribute.unit_price && parseFloat(attribute.unit_price) > 0"    class="cost-attribute"  style="text-align: left;">
                             +{{ priceText(attribute.unit_price, attribute.cost_type,currency,unit) }}

                        </span>
                        </label>

                        <textarea :id="id" v-model="attribute.value" :name="name"
                                  class="form-control new-inputs">{{attribute.value}}</textarea>
                    </div>

                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
    </validation-observer>
</template>


<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {priceText} from "@/events/sharedMethods";

export default {
    name: "LongtextAttribute",
    props: {
        value: {
            type: Object,
            required: true
        },
        currency: {
            required: true
        },
        unit: {
            required: true
        },
        clone: 0
    },
    data() {
        return {
            attribute: this.value
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        }
    },
    methods: {
        triggerChange() {
            EventBus.$emit('onServiceCustomFieldSelected', this.attribute.service_id, this.clone)
        },
        addEventListeners() {

            EventBus.$on('onServiceaAttribusteLongText', value => {
                EventBus.$emit('serviceChanged',[]);
            })
            EventBus.$on('onServiceAttributesValidation', async (verify) => {
                let validated = await this.$refs.longtextForm.validate();
                if (!validated) {
                    /** If there is a validation error then show the validation and open collapsed services  **/
                    EventBus.$emit('onCollapseService', this.attribute)

                }
                verify(validated)
            })


        },
        onChange(event) {
            this.attribute.value = event.target.value
            this.$emit('input', event.target.value)
        },
        removeTags(value) {
            const div = document.createElement('div');
            div.innerHTML = value;
            var DataToAdd=null
            if(div.textContent){
                DataToAdd= div.textContent
            }
            else if(div.innerText){
                DataToAdd= div.innerText
            }else{   DataToAdd= '';  }
            if(DataToAdd){
                return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${DataToAdd}</div>`;
            }else {
                return DataToAdd;
            }
            },
        popover_custom_data(value) {
            return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${value}</div>`;;
        },
        priceText,
        addDefaultValue() {
            if (this.clone > 0) {
                // return
            }

            if (this.attribute.service_attribute_value) {
                this.attribute.value = this.attribute.service_attribute_value
            } else if (this.attribute.attribute_description) {
                this.attribute.value = this.attribute.attribute_description
            } else if (this.attribute.attribute_name == 'Service Manual' || this.attribute.attribute_name == 'Description') {
                if (this.attribute.service_attribute_value) {
                    this.attribute.value = this.attribute.service_attribute_value
                } else {
                    this.attribute.value = this.attribute.default_value
                }
            } else {
                this.attribute.value = this.attribute.service_attribute_value
            }
        }
    },
    mounted() {
        this.addEventListeners()
        this.addDefaultValue()
    },
    watch: {
        attribute: {
            handler: function (attribute) {
                this.triggerChange();
                this.$emit('input', attribute)
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 11px;
}
</style>